import PdfViewerComponent from './PdfViewerComponent';
import ViewClientInfo from '../../../../components/Proposal/ViewClientInfo';
import { Box, Typography } from '@mui/material';
import ClientCreationWrapper from '../../../../components/HOC/ClientCreationWrapper';

const ViewInfo = ({
  client,
  selectedVersionInfo,
  versionData,
  createPdfLoading,
  pdfUrl,
  isLoading,
  state,
  productLabel,
  planTypeLabel,
  handleCreatePDF,
}) => {
  return (
    <div style={{ overflow: 'hidden' }}>
      <div style={{ float: 'left', width: '35%' }}>
        <ViewClientInfo
          data={client}
          versionInfo={selectedVersionInfo}
          versionData={versionData}
          isLoading={isLoading}
          state={state}
          productLabel={productLabel}
          planTypeLabel={planTypeLabel}
        />
      </div>
      <div style={{ float: 'right', width: 'calc(65% - 10px)', marginLeft: '10px' }}>
        {createPdfLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant="h6">Processing, please wait.........</Typography>
          </Box>
        )}
        <PdfViewerComponent pdfUrl={pdfUrl} handleCreatePDF={handleCreatePDF} />
      </div>
    </div>
  );
};

export default ClientCreationWrapper(ViewInfo);
